import React from 'react';

export const ArrowSolidLeft = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--arrow-solid-left';
  color = color || '#0076CC';

  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M0.65165 4.56385C-0.0604839 4.91151 -0.104564 5.90987 0.574159 6.31894L8.4838 11.0862C9.15029 11.4879 10 11.0079 10 10.2297L10 1.601C10 0.861762 9.2256 0.378063 8.56129 0.702375L0.65165 4.56385Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowSolidLeft;
